import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import axios from 'axios'
import i18n from './i18n'

import Storage from 'vue-ls'

const options = {
  namespace: 'vuejs__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', // storage name session, local, memory
};
 
Vue.use(Storage, options);
 

// import Chart from 'chart.js'
// import canvg from "canvg"

// import pdfMake from "pdfmake-lite/build/pdfmake";
// import pdfMake from "pdfmake/build/pdfmake.min";
// import './fontloader.js'
// import pdfFonts from "pdfmake-lite/build/vfs_fonts";
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

Vue.config.productionTip = false
// Vue.use(Chart) 

router.beforeEach((to, from, next) => {
  let language = to.params.lang
  if (!language) {
    language = 'en'
  }

  if ( language != i18n.locale)
    language = i18n.locale
    
  i18n.locale = language
  next()
})

Vue.prototype.$scrollToTop = () => window.scrollTo(0,0)

var debug = false
// var debug = true

Vue.config.productionTip = !debug
Vue.prototype.$http = axios
if (debug) {
  Vue.prototype.$API_URL = "http://localhost:9090/api/";
  Vue.prototype.$PDF_URL = "http://localhost:9095/pdf";
  Vue.prototype.$CARTPDF_URL = "http://localhost:9095/cart-pdf";
  Vue.prototype.$XLSX_URL = "http://localhost:9095/cart-xlsx";

} else {
  Vue.prototype.$API_URL = "http://maxisu.api.yazilimsalcozumler.com/api/";
  Vue.prototype.$PDF_URL = "http://pdfmaxisu.yazilimsalcozumler.com:9095/pdf";
  Vue.prototype.$CARTPDF_URL = "http://pdfmaxisu.yazilimsalcozumler.com:9095/cart-pdf";
  Vue.prototype.$XLSX_URL = "http://pdfmaxisu.yazilimsalcozumler.com:9095/cart-xlsx";
}


window.myvue = new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
